import React, { Component } from 'react'
import { Icon, Table, Popconfirm, Button, Input, Select, InputNumber } from 'antd'
import { app, api } from '../../../app'
import { forEach } from 'underscore';

const Option = Select.Option


class AddNoSystemPerson extends Component {
    // 组件内部
    constructor(props) {
        super(props);
        // let Editor = 1
        // if (props.Editor != undefined) {
        //     Editor = 2
        // }
        let data = []
        let writeFlag = false
        if (props.noSystemTeamManInfo.length >= 1) {
            props.noSystemTeamManInfo.forEach((i, v) => {
                let member = {}
                member.id = v
                member.bsrno = i.bsrno
                member.idno = i.idno
                member.join_type = i.join_type
                member.mobile = i.mobile
                member.name = i.name
                member.original_teamno = i.original_teamno
                member.sex = i.sex
                member.state = i.state
                member.sex = i.sex
                member.teamname = i.teamname
                member.teamposition_id = i.teamposition_id
                member.flag = true
                data.push(member)
            })
            writeFlag = true
        }

        // if(props.com2 != undefined) {
        //     data = props.com2.volunteer
        // }
        this.state = {
            data: data,
            addFlag: true,
            teamPositionSelectList: [],
            Editor: props.Editor,
            writeFlag: writeFlag
        }
        this.getTeamPositionSelectList()
        this.handleData()
    }

    componentDidMount() {

    }


    handleData = () => {

    }

    //获取select队内身份列表信息
    getTeamPositionSelectList = () => {
        app.post(api.TeamPositionSelectList, {}).then(res => {
            // console.log(res)
            if (res.flag == 1) {
                this.setState({
                    teamPositionSelectList: res.data
                })
            }

        })
    }

    // 设置暂存
    setCacheVolunteer = () => {
        if (!this.state.writeFlag) {
            return
        }
        const info = app.getData('InitialInfo')
        const { data } = this.state
        if (data.length < 1) {
            return
        }
        // console.log(info)
        const volunteer_json = []
        // console.log(data)
        //如果当前非系统table列表中有数据
        if (data.length > 0) {
            data.forEach(i => {
                let memberInfo = {}
                memberInfo.name = i.name
                memberInfo.mobile = i.mobile
                memberInfo.idno = i.idno
                memberInfo.sex = i.sex
                memberInfo.teamposition_id = i.teamposition_id
                volunteer_json.push(memberInfo)
            })
        }
        // console.log(volunteer_json)
        const param = {
            area_id: info.city_id[0],
            city_id: info.city_id[1],
            teamname: info.teamname,
            name: info.name,
            idno: info.idno,
            mobile: info.mobile,
            sms: info.sms,
            sex: info.sex,
            volunteer_type: 1,
            volunteer_json: JSON.stringify(volunteer_json)
        }
        // console.log(param)
        app.post(api.TeamSetCacheVolunteer, param).then(res => {
            // console.log(res)
            if (res.flag == 1) {
                app.alert(res.msg, 'success', '45%')

            } else {
                app.alert(res.msg, 'error', '45%')
            }
        })
    }

    // 添加队员操作栏
    addInput = () => {
        const data = this.state.data;
        data.push(
            {
                id: data.length,
                name: '',
                mobile: '',
                idno: '',
                sex: '',
                teamID: '志愿者',
                teamposition_id: ''
            }
        )
        this.setState({
            data,
            addFlag: false,
            writeFlag: false
        })
    }




    //获取性别
    getSex = (e) => {
        const data = this.state.data;
        data[data.length - 1].sex = e
        this.setState({
            data
        })
    }

    //获取职务
    getPosition = (e) => {
        const data = this.state.data;
        data[data.length - 1].teamposition_id = e
        this.setState({
            data
        })
    }


    _changeValue = (e, info) => {
        let name = e.target.name
        const { data } = this.state;
        data.forEach((i, v) => {
            if (i.id == info.id) {
                i[name] = e.target.value
            }
        })
        this.setState({
            data
        })
    }


    // 用户确认了添加的队员信息
    confiAdd = () => {
        // console.log(this.state.data)
        const info = this.state.data;
        const data = info[info.length - 1]

        // data.forEach((i, v) => {
        //     if (i.name == '') {
        //         console.log(1)
        //         app.alert('新增队员未设置姓名', 'error', '45%')
        //         return
        //     }
        //     if (i.mobile == '') {
        //         app.alert('新增队员未设置手机号码', 'error', '45%')
        //         return
        //     }
        //     if (i.idno == '') {
        //         app.alert('新增队员未设置身份证号码', 'error', '45%')
        //         return
        //     }
        //     if (i.sex == '' || i.sex == undefined) {
        //         app.alert('新增队员未设置性别', 'error', '45%')
        //         return
        //     }
        //     if (i.teamposition_id == '' || i.teamposition_id == undefined) {
        //         app.alert('新增队员分配队内职务', 'error', '45%')
        //         return
        //     }
        //     flag = true
        // })
        if (data.name == '') {
            app.alert('请编辑新增队员姓名', 'error', '45%')
            return
        } else {
            if (data.mobile == '') {
                app.alert('请编辑新增队员电话号码', 'error', '45%')
                return

            } else {
                if (data.idno == '') {

                    app.alert('请编辑新增队员身份证号码', 'error', '45%')
                    return

                } else {
                    let p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
                    if (!(p.test(data.idno))) {
                        // 身份证号验证不正确
                        app.alert("身份证号格式错误", "error")
                        return
                    }
                    if (info.length > 1) {
                        for (let i = 0; i < info.length - 1; i++) {
                            if (info[i].idno == data.idno) {
                                app.alert('身份证号码重复，请重新编辑', 'error', '45%')
                                return
                            }
                        }
                    }


                    if (data.sex == '' || data.sex == undefined) {
                        app.alert('请选择新增队员性别', 'error', '45%')
                        return

                    } else {
                        if (data.position == '' || data.teamposition_id == undefined) {
                            app.alert('请选择新增队员队内职务', 'error', '45%')
                            return

                        } else {
                            info[info.length - 1].flag = true
                            // 所有内容都准备就绪
                            this.setState({
                                addFlag: true,
                                data: info,
                                writeFlag: true
                            })

                        }
                    }
                }
            }
        }
        // console.log(this.state.data)
    }

    //移除对应队员信息
    deleInfo = (info) => {
        const { data } = this.state;
        // console.log(data)
        // console.log(info)
        // const data = this.state.data
        data.forEach((i, v) => {
            if (i.id == info.id) {
                data.splice(v, 1)
            }
        })
        this.setState({
            data
        })
    }

    tijiaofu = () => {
        // console.log(this.state.data)
        if (this.state.data.length < 1) {
            app.alert('没有队员信息', 'error', '45%')

        } else {
            this.props.tijiao(this.state.data, 1)
        }
    }


    next = () => {
        if (!this.state.writeFlag) {
            return
        }
        const { data } = this.state;
        if (data.length < 1) {
            return
        }
        // console.log(data)
        let flag = false
        data.forEach((i, v) => {
            if (i.name == '') {
                // console.log(1)
                app.alert('新增队员未设置姓名', 'error', '45%')
                return
            }
            if (i.mobile == '') {
                app.alert('新增队员未设置手机号码', 'error', '45%')
                return
            }
            if (i.idno == '') {
                app.alert('新增队员未设置身份证号码', 'error', '45%')
                return
            }
            if (i.sex == '' || i.sex == undefined) {
                app.alert('新增队员未设置性别', 'error', '45%')
                return
            }
            if (i.teamposition_id == '' || i.teamposition_id == undefined) {
                app.alert('新增队员分配队内职务', 'error', '45%')
                return
            }
            flag = true
        })
        if (flag) {




            const info = app.getData('InitialInfo')

            // console.log(info)
            const volunteer_json = []
            // console.log(data)
            //如果当前非系统table列表中有数据
            if (data.length > 0) {
                data.forEach(i => {
                    let memberInfo = {}
                    memberInfo.name = i.name
                    memberInfo.mobile = i.mobile
                    memberInfo.idno = i.idno
                    memberInfo.sex = i.sex
                    memberInfo.teamposition_id = i.teamposition_id
                    volunteer_json.push(memberInfo)
                })
            }
            // console.log(volunteer_json)
            const param = {
                area_id: info.city_id[0],
                city_id: info.city_id[1],
                teamname: info.teamname,
                name: info.name,
                idno: info.idno,
                mobile: info.mobile,
                sms: info.sms,
                sex: info.sex,
                volunteer_type: 1,
                volunteer_json: JSON.stringify(volunteer_json)
            }
            // console.log(param)
            app.post(api.TeamSetCacheVolunteer, param).then(res => {
                // console.log(res)
                if (res.flag == 1) {
                    app.alert(res.msg, 'success', '45%')
                    this.props.setPage(4)
                } else {
                    app.alert(res.msg, 'error', '45%')
                }
            })




            
        }

    }



    // 页面渲染区
    render() {
        let { data, addFlag, teamPositionSelectList } = this.state
        const columns = [
            {
                title: '姓名',
                width: 200,
                render: (Info) => <div>

                    <Input type="text" onChange={(e) => this._changeValue(e, Info)} name="name" width={150} value={Info.name} maxLength={10} disabled={this.props.examine == 1 || this.props.detailF == 1} />
                </div>,
            },
            {
                title: '手机号码',
                width: 300,
                key: 'mobile',
                render: (Info) => <div>
                    <Input type="text" onChange={(e) => this._changeValue(e, Info)} name="mobile" width={250} value={Info.mobile} maxLength={11} disabled={this.props.examine == 1 || this.props.detailF == 1} />
                </div>,
            },
            {
                title: '身份证号码',
                key: 'idno',
                width: 500,
                render: (Info) => <div>
                    <Input type="text" onChange={(e) => this._changeValue(e, Info)} name="idno" width={450} value={Info.idno} maxLength={18} disabled={this.props.examine == 1 || this.props.detailF == 1} />
                </div>,
            },
            {
                title: '性别',
                dataIndex: 'sex',
                width: 100,
                key: 'sex',
                render: (data) =>
                    <Select placeholder="请选择" style={{ width: 120 }} onChange={this.getSex} allowClear defaultValue={data} disabled={this.props.examine == 1 || this.props.detailF == 1}>
                        <Option value="男">男</Option>
                        <Option value="女">女</Option>
                    </Select>
            },
            {
                title: '队员身份',
                dataIndex: 'teamID',
                key: 'teamID',
                width: 100,
                render: (teamID) => <div>
                    <Input type="text" value={teamID == undefined ? '志愿者' : teamID} disabled={true} />
                </div>,
            },
            {
                title: '分配队内职务',
                dataIndex: 'teamposition_id',
                key: 'teamposition_id',
                width: 200,
                render: (data) =>
                    <Select placeholder="请选择" style={{ width: 120 }} onChange={this.getPosition} allowClear defaultValue={data} disabled={this.props.examine == 1 || this.props.detailF == 1}>
                        {teamPositionSelectList.map((item, index) =>
                            <Option key={item.id} value={item.id} disabled={item.name == '队员' || item.name == '预备队员' ? true : false}>{item.name}</Option>
                        )}
                    </Select>
            },
            {
                title: '操作',
                key: 'operation',
                width: 100,
                render: (Info) => <div>
                    {this.props.examine == 1 || this.props.detailF == 1 ? '' : !Info.flag ? <Button onClick={() => this.confiAdd()}>确认</Button> : <Button onClick={() => this.deleInfo(Info)}>移除</Button>}
                </div>,
            },
        ];


        return (
            <div >
                <div style={{ marginTop: 20 }}>
                    {/* 组件标题 */}
                    <p style={{ fontSize: 16 }} >申请筹备组队员信息如下：</p>
                    {/* 组件标题end */}

                    {this.props.examine == 1 || this.props.detailF == 1 ? '' : addFlag ? <Button onClick={() => this.addInput()} style={{ backgroundColor: '#1890FF', color: '#fff', marginBottom: 10 }}>添加队员信息</Button> : <Button style={{ marginBottom: 10 }}>编辑中</Button>}
                    <div>
                        <Table columns={columns} dataSource={data} scroll={{ x: 1500, y: 300 }} />

                    </div>

                </div>









                {/* 功能按钮 */}
                <div style={{ paddingTop: 80, display: 'flex', justifyContent: 'center' }} hidden={this.state.Editor == 2}>
                    <Button style={{ width: 300, marginRight: 50 }} onClick={() => this.props.setPage(2)}>上一步</Button>
                    {/* onClick={this.golast} */}
                    <Button style={{ width: 300, }} onClick={this.setCacheVolunteer}>暂存</Button>
                    {/* onClick={this.setNowAllData} */}
                    <Button style={{ width: 300, marginLeft: 50, backgroundColor: '#1890FF', color: '#fff' }} onClick={() => this.next()}>下一步</Button>
                    {/* onClick={this.goNext} */}
                </div>
                {/* 功能按钮end */}

                {/* 功能按钮 */}
                <div style={{ paddingTop: 80, display: 'flex', justifyContent: 'center' }} >

                    {
                        this.props.examine == 1 || this.props.detailF == 1 ? '' : this.state.Editor == 2 ? <Button style={{ width: 300, backgroundColor: '#1890FF', color: '#fff', }} onClick={this.tijiaofu}>提交队员信息</Button> : ''

                    }
                </div>
                {/* 功能按钮end */}

            </div>

        )
    }
}



export default AddNoSystemPerson



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/AddNoSystemPerson.jsx